import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { trainingApi } from '../../services';
import { toast } from "react-toastify";
import { Card } from "primereact/card";
import { FileUpload } from 'primereact/fileupload';
import { Dropdown } from "primereact/dropdown";

const UploadTrainingDocuments = () => {
    const fileRef = useRef(null);
    const [fileObjArray, setFileObjArray] = useState([]);

    // const [selectedCity, setSelectedCity] = useState(null);
    // const cities = [
    //     { name: 'New York', code: 'NY' },
    //     { name: 'Rome', code: 'RM' },
    //     { name: 'London', code: 'LDN' },
    //     { name: 'Istanbul', code: 'IST' },
    //     { name: 'Paris', code: 'PRS' }
    // ];

    // useEffect(() => {
    //     fetchActiveTrainingList()
    // }, []);

    const onUpload = (e) => {
        const selectedFiles = e.files || [];
        const validFiles = [];

        selectedFiles.forEach(file => {
            const isXlsx = file.name.endsWith('.xlsx') &&
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (!isXlsx) {
                toast.error(`${file.name} is not a valid .xlsx file.`);
            } else {
                validFiles.push(file);
            }
        });

        if (validFiles.length > 0) {
            setFileObjArray(validFiles);
        } else {
            fileRef.current?.clear(); // Clear file if invalid
            setFileObjArray([]);
        }
    };

    const uploadEmpAssessment = async (type) => {
        if (fileObjArray.length === 0) {
            toast.warning("Please select .xlsx file to upload.");
            return;
        }
        try {
            await uploadFiles(fileObjArray, type);
            setFileObjArray([]);
            fileRef.current?.clear();
            toast.success("File uploaded successfully.");
        } catch (error) {
            toast.error("Failed to upload file.");
        }
    };

    const uploadFiles = async (files, type) => {
        return new Promise((resolve, reject) => {
            try {
                const formData = new FormData();
                for (let i = 0; i < files.length; i++) {
                    formData.append('file', files[i]);
                }

                trainingApi.uploadAttachment(formData, type).then(resp => {
                    const attachment = resp?.data?.data;
                    if (Array.isArray(attachment)) {
                        const fileArr = attachment.map(x => x.fileName);
                        resolve(fileArr.join(','));
                        // setFileObjArray([])
                        // fileRef.current?.clear();
                        // setFiles([]);
                    } else {
                        resolve(null);
                    }
                }).catch(err => {
                    reject(err);
                });
            } catch (error) {
                reject(error);
            }
        });
    };

    return (
        <div className='card'>
            <div className='grid'>
                <div className='col-12 md:col-6'>
                    <Card title="Upload Employee Assessment (.xlsx only)">
                        {/* <div className="p-2">
                            <Dropdown value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={cities} optionLabel="name"
                                placeholder="Select a City" className="w-full md:w-14rem" />
                        </div> */}
                        <FileUpload
                            ref={fileRef}
                            name="file[]"
                            multiple
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            maxFileSize={1000000}
                            customUpload
                            uploadHandler={() => uploadEmpAssessment('Assesment')}
                            onSelect={onUpload}
                            emptyTemplate={
                                <p className="m-0" style={{ minHeight: '200px' }}>
                                    Drag and drop .xlsx files here to upload.
                                </p>
                            }
                        />

                    </Card>
                </div>

                <div className='col-12 md:col-6'>
                    <Card title="Upload Employee Feedback (.xlsx only)">
                        <FileUpload
                            ref={fileRef}
                            name="file[]"
                            multiple
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            maxFileSize={1000000}
                            customUpload
                            uploadHandler={() => uploadEmpAssessment('Feedback')}
                            onSelect={onUpload}
                            emptyTemplate={
                                <p className="m-0" style={{ minHeight: '200px' }}>
                                    Drag and drop .xlsx files here to upload.
                                </p>
                            }
                        />
                        {/* <div className="p-2">
                            <Button
                                label="Submit"
                                className='p-button-secondary'
                                type='button'
                                onClick={uploadEmpAssessment}
                            />
                        </div> */}
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default UploadTrainingDocuments;
